module.exports = __webpack_public_path__ + "img/jewelrybox@2x.0825f49.jpg";